
import * as React from "react";
import { Checkbox } from "../../../avernus/checkbox/source/Checkbox";
import { Lng } from "../../../languages/Languages";
import { ISetUrl } from "../../AppMain";

interface IRegCheckboxesProps extends IForm {
    changed:IchangedFunction
    setUrl:ISetUrl
}

interface IchangedFunction{
    (acceptedAll:boolean, form:IForm):void
}


interface IRegCheckboxesState {
    form: IForm
}

interface IForm{
    privacyPolicyAccepted               : number
    aszfAccepted                        : number

}

export default class RegCheckboxes extends React.Component<IRegCheckboxesProps, IRegCheckboxesState>{

    constructor(props:IRegCheckboxesProps){
        super(props);
        this.state = {
            form: {
                privacyPolicyAccepted               : this.props.privacyPolicyAccepted,
                aszfAccepted                        : this.props.aszfAccepted,

            }
        }
    }

    private changeInputHandler(evt, type:string, value?:string|number): void {
        var form = this.state.form;
        if ( evt !== undefined) {
            evt.preventDefault();
            form[type] = evt.target.value;
        }else{
            form[type] = value;
        }
        this.setState({
            form: form
        }, ()=>{
            let acceptedAll = true;
            for (var key in this.state.form) {
                var item = this.state.form[key];
                if ( item === 0 ) {
                    acceptedAll = false;
                }
            }
            this.props.changed(acceptedAll, this.state.form);
        });
    }

    private gotoPrivacyPolicy(evt): void {
        evt.preventDefault();
        this.props.setUrl('/user/privacy-policy');
    }

    private openPdf(evt, link:string):void{
        evt.preventDefault();
        if ( link.indexOf('https://') == -1 ) {
            link = 'https://opus.ecom-hosting.hu/' + link;
        }
    }

    render() {
        return (
            <>
                <div className="row">
                    <div className="col">
                        <Checkbox
                            key={"formCheck-aszfAccepted_"+ this.state.form.aszfAccepted }
                            defaultChecked={ this.state.form.aszfAccepted===1 }
                            label={Lng.get('user_profile_aszf')}
                            value = { '1' }
                            checkedIconClass="sfc_cb_on"
                            notCheckedIconClass="sfc_cb_off"
                            onChange = { (checked, value) => {
                                if ( checked === true) {
                                    this.changeInputHandler(undefined, 'aszfAccepted', 1);
                                }
                            }}
                        >
                            {Lng.get('user_profile_agreetoour')} <a href="#" target="_blank" onClick={ (e) => { this.openPdf(e, "#"); } }>
                            {Lng.get('user_profile_aszf2')}
                            </a>
                        </Checkbox>
                    </div>
                </div>


                <div className="row">
                    <div className="col">
                        <Checkbox
                            key={"formCheck-privacyPolicyAccepted_"+ this.state.form.privacyPolicyAccepted }
                            defaultChecked={ this.state.form.privacyPolicyAccepted===1 }
                            label={Lng.get('user_profile_privacypol')}
                            value = { '1' }
                            checkedIconClass="sfc_cb_on"
                            notCheckedIconClass="sfc_cb_off"
                            onChange = { (checked, value) => {
                                if ( checked === true) {
                                    this.changeInputHandler(undefined, 'privacyPolicyAccepted', 1);
                                }
                            }}
                        >
                                {Lng.get('user_profile_agreetoour')} <a href="#" target="_blank" onClick={ (e) => { this.openPdf(e, "#"); } }>
                                {Lng.get('user_profile_privacypol2')}
                            </a>
                        </Checkbox>
                    </div>
                </div>
			</>
        );
    }
}
